(($)=>{
   const $masthead = $('#masthead');
   const $menu = $('.menu-main', $masthead);
   const $sideMenu = $('#header-side-menu');
   const $sideMenuToggle = $('#side-menu-toggle');
   const $sideMenuOverlay = $('#header-side-menu-overlay');

    $('.menu-item-has-children a', $menu).on('focus', function(event){

    	const $a = $(this);
    	const $li = $a.closest('.menu-item-has-children');
    	const $subnavToggler = $a.hasClass('.subnav-toggler') ? $a : $('a.subnav-toggler', $li);
    	$subnavToggler.attr('aria-expanded', 'true');

    	$li.addClass('shown');

    }).on('blur',function(){

    	const $a = $(this);
    	const $li = $a.closest('.menu-item-has-children');
    	const $subnavToggler = $a.hasClass('.subnav-toggler') ? $a : $('a.subnav-toggler', $li);
    	$subnavToggler.attr('aria-expanded', 'false');

    	$li.removeClass('shown');

    }).on('keydown',function(e){
    	// trigger click on enter and space keys on focused sub link.
    	if(e.which && (e.which===13 || e.which === 32) ){
    		this.click();
    	}
    });

    // $('.menu-item-has-children .subnavbar-toggler', $menu).on('click', function(event){
    //
    //     const $a = $(this);
    //     const $li = $a.parent();
    //     const $parents = $li.parents('.menu-item-has-children');
    //
    //     if($a.attr('aria-expanded') === "true" ){
    //         $a.attr('aria-expanded', 'false');
    //         $li.removeClass('shown');
    //         $parents.removeClass('sub-shown');
    //
    //         if($parents.length < 1){
    //             $mobileMasthead.removeClass('submenu-opened');
    //         }
    //
    //         event.preventDefault();
    //
    //     }else{
    //         mobileMenuEl.scrollTop = 0;
    //         $a.attr('aria-expanded', 'true');
    //         $li.addClass('shown');
    //         $parents.addClass('sub-shown');
    //         $mobileMasthead.addClass('submenu-opened');
    //     }
    //
    //     event.preventDefault();
    //
    // });

	$sideMenuToggle.on('click', function toggleSideMenu(event){
		$sideMenu.toggleClass('menu-opened');
		$sideMenuToggle.toggleClass('is-active');
		let headerHeight = $masthead.outerHeight();
		const headerLineHeight = $('.header-line').outerHeight();
		$sideMenu.scrollTop(0);
		// if(headerLineHeight){
		// 	headerHeight +=headerLineHeight;
		// }
		if($sideMenu.hasClass('menu-opened')){
			document.body.style.overflow='hidden';
		}else{
			document.body.style.overflow='';
		}

		$sideMenuOverlay.toggleClass('active');
		$sideMenu.css({
			height: `${window.innerHeight - (headerHeight + headerLineHeight)}px`,
			top: `${(headerHeight + headerLineHeight)}px`,
		});

	});

	$(window).on('resize orientationchange load', function resizeDesktopSideMenu(){
		if($sideMenu.hasClass('menu-opened')){

			let headerHeight = $masthead.outerHeight();
			const headerLineHeight = $('.header-line').outerHeight();

			$sideMenu.css({
				height: `${window.innerHeight - (headerHeight + headerLineHeight)}px`,
				top: `${(headerHeight + headerLineHeight)}px`,
			});
		}

	});

	$('.menu-item-has-children .subnavbar-toggler', $sideMenu).on('click', function(event){

		const $a = $(this);
		const $li = $a.parent();
		const $parents = $li.parents('.menu-item-has-children');

		if($a.attr('aria-expanded') === "true" ){
			$a.attr('aria-expanded', 'false');
			$li.removeClass('shown');
			$parents.removeClass('sub-shown');

			if($parents.length < 1){
				$sideMenu.removeClass('submenu-opened');
			}

			event.preventDefault();

		}else{
			$sideMenu.scrollTop(0);
			$a.attr('aria-expanded', 'true');
			$li.addClass('shown');
			$parents.addClass('sub-shown');
			$sideMenu.addClass('submenu-opened');
		}

		event.preventDefault();

	});

})(jQuery)